var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className},[_c('span',[_vm._v(_vm._s(_vm.prefix))]),_c('span',{staticClass:"balance"},[_vm._v(_vm._s(_vm.formatted))]),_c('span',[_vm._v(_vm._s(_vm.suffix))])])
}
var staticRenderFns = []

export { render, staticRenderFns }